import { PPLX_VISITOR_ID_COOKIE } from '#pplx/frontend/cookies/constants.js';
import { getCookie } from '#pplx/frontend/cookies/provider.js';
import { fetchWithTimeout as httpFetch } from '#pplx/frontend/fetcher/core.js';
const isJsonContentType = (contentType) => contentType?.toLowerCase().includes('json') ?? false;
const parseNavigationalSearchResponse = async (response) => {
    if (!response.ok) {
        return undefined;
    }
    const responseText = await response.text();
    if (!responseText.trim()) {
        return undefined;
    }
    const contentType = response.headers.get('content-type');
    if (contentType && !isJsonContentType(contentType)) {
        return undefined;
    }
    try {
        return JSON.parse(responseText);
    }
    catch {
        return undefined;
    }
};
export const fetchNavigationalSearchV3 = async ({ query, reason, streamId, streamTimer, provider, userIdentity, }) => {
    streamTimer?.addTimingOnce('web.frontend.v3_navigation_request_sent_ms');
    const body = {
        query,
        ...(streamId && { cache_key: streamId }),
        ...(provider && { provider }),
        ...(userIdentity && { user_identity: userIdentity }),
    };
    const visitorId = getCookie(PPLX_VISITOR_ID_COOKIE);
    const response = await httpFetch({
        resource: 'https://suggest.perplexity.ai/search/v3/navigate',
        method: 'POST',
        options: {
            headers: {
                'content-type': 'application/json',
                'X-Client-Name': 'agi_ui_navigate_v3',
                'X-Client-Env': 'production',
                ...(visitorId && { 'X-Visitor-Id': visitorId }),
            },
        },
        body: JSON.stringify(body),
        timeoutMs: 1000,
        reason,
    });
    streamTimer?.addTimingOnce('web.frontend.v3_navigation_results_received_ms');
    return parseNavigationalSearchResponse(response);
};
//# sourceMappingURL=fetchNavigationalSearchV3.js.map